(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define([], factory);
	else if(typeof exports === 'object')
		exports["payment-frontend-main"] = factory();
	else
		root["payment-frontend-main"] = factory();
})(window, () => {
return 